import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input'];

  minus() {
    this.inputTarget.stepDown();
  }

  plus() {
    this.inputTarget.stepUp();
  }
}
